

















































































import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import { KFiSelector } from '@kasasa/fbase-components';
import LocalDateTime from '@/types/localdatetime';
import TextBoxDatePicker from '@/components/textboxdatepicker.vue';
import UserSelector from '@/components/userselector.vue';
import { AuditEntry } from '@/api/audit/AuditEntry';
import AuditResource from '@/api/audit/AuditResource';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';

interface AuditTableEntry {
	fiId: number | null;
	time: number[];
	sortableTime: number | null;
	friendlyTime: string;
	userName: string;
	api: string;
	method: string;
	message: string;
}

@Component({
  components: {
    'fi-selector': KFiSelector,
    'user-selector': UserSelector,
    'text-box-date-picker': TextBoxDatePicker,
  },
})
export default class AuditLog extends Vue {
	loading: boolean = false;

	headers: any = [
	  { text: 'FI ID', value: 'fiId' },
	  { text: 'Time', value: 'sortableTime' },
	  { text: 'User', value: 'userName' },
	  { text: 'API', value: 'api' },
	  { text: 'Method', value: 'method' },
	  { text: 'Message', value: 'message' },
	];

	errorMessage: string = '';

	items: AuditTableEntry[] = [];

	@Inject('AuditResource')
	private auditResource!: AuditResource;

	selectedFi: string = '';

	selectedUser: string = '';

	options: any = {
	  sortDesc: [true],
	  sortBy: ['sortableInitiated'],
	};

	services: Map<string, string> = new Map([
	  ['posting-config-setup', 'Posting Configurations'],
	  ['rcx-config', 'Rewards Configurations'],
	  ['rcx-reporting', 'Rewards Processing'],
	  ['krp-techops-admin', 'Techops Admin'],
	]);

	filter: any = AuditLog.getClearFilter();

	footerProps: any = {
	  'items-per-page-options': [25, 50, 100, { value: -1, text: 'All' }],
	};

	clearFilter() {
	  this.filter = AuditLog.getClearFilter();
	}

	static getClearFilter() {
	  return {
	    selectedFi: {},
	    selectedUser: {},
	    services: [],
	    startDateString: undefined,
	    endDateString: new Date().toISOString().substr(0, 10),
	  };
	}

	loadLogs() {
	  this.loading = true;

	  this.auditResource
	    .getAll(this.buildFilterParams())
	    .then((result: AuditEntry[]) => {
	      this.buildAuditTableEntries(result);
	    })
	    .catch((error: any) => {
	      this.showError(error);
	    });
	  this.loading = false;
	}

	onNewStartDate(date: string) {
	  this.filter.startDateString = date;
	  const localDate: LocalDateTime = new LocalDateTime(date);
	}

	onNewEndDate(date: string) {
	  this.filter.endDateString = date;
	  const localDate: LocalDateTime = new LocalDateTime(date);
	}

	buildFilterParams() {
	  let params = '';

	  if (
	    this.filter.selectedFi !== undefined
			&& this.filter.selectedFi.fiId !== undefined
	  ) {
	    params = AuditLog.addFilterParam(
	      params,
	      'fiId',
	      this.filter.selectedFi.fiId,
	    );
	  }

	  if (
	    this.filter.selectedUser !== undefined
			&& this.filter.selectedUser.id !== undefined
	  ) {
	    params = AuditLog.addFilterParam(
	      params,
	      'userId',
	      this.filter.selectedUser.id,
	    );
	  }

	  if (this.filter.startDateString) {
	    params = AuditLog.addFilterParam(
	      params,
	      'startDate',
	      this.filter.startDateString,
	    );
	  }

	  if (this.filter.endDateString) {
	    params = AuditLog.addFilterParam(
	      params,
	      'endDate',
	      this.filter.endDateString,
	    );
	  }

	  if (this.filter.services.length > 0) {
	    let services: string = this.filter.services[0][0];
	    for (let i: number = 1; i < this.filter.services.length; i++) {
	      services += `,${this.filter.services[i][0]}`;
	    }

	    params = AuditLog.addFilterParam(params, 'services', services);
	  }

	  return params;
	}

	buildAuditTableEntries(auditItems: AuditEntry[]) {
	  this.items = [];
	  for (let i = 0; i < auditItems.length; i++) {
	    this.items.push(AuditLog.buildTableEntry(auditItems[i]));
	  }
	}

	static buildTableEntry(item: AuditEntry): AuditTableEntry {
	  const time: LocalDateTime = new LocalDateTime(item.time);

	  return {
	    fiId: item.fiId,
	    time: item.time,
	    sortableTime: time.toDate().getTime(),
	    friendlyTime: time.toFriendlyDateTimeString(),
	    userName: item.userName,
	    api: item.api,
	    method: item.method,
	    message: item.message,
	  };
	}

	static addFilterParam(params: string, name: string, value: string) {
	  let newParams: string = params;

	  if (newParams.length === 0) {
	    newParams += '?';
	  } else {
	    newParams += '&';
	  }

	  newParams += `${name}=${value}`;
	  return newParams;
	}

	hasValidFilter() {
	  return (
	    this.filter.services !== undefined && this.filter.services.length > 0
	  );
	}

	showError(error: any) {
	  if (error.response && error.response.data && error.response.data.entity) {
	    this.setError(error.response.data.entity);
	  } else {
	    this.setError('An unexpected error occurred.');
	  }
	}

	setError(message: string) {
	  const al = new Alert(message, NoticeClass.ERROR);
	  al.setTimeout(5000);
	  this.$store.dispatch('notices/add', al);
	}
}
